export default "__VITE_ASSET__96eadd03__"